import { Action, State, StateContext, Store } from '@ngxs/store';

import { Designation } from './designation.model';
import * as DesignationActions from './designation.actions';
import { DonationActions } from '../donation';

export interface DesignationStateModel {
  items: Designation[];
  total: number;
  custom: string;
  notes: { id: number; value: string }[];
  active: boolean;
  p2pComments: string;
}

@State<DesignationStateModel>({
  name: 'designations',
  defaults: {
    items: [],
    total: 0,
    custom: '',
    notes: [],
    active: false,
    p2pComments: ''
  }
})
export class DesignationState {
  constructor(private store: Store) {}

  @Action(DesignationActions.ActivateDesignation)
  activateDesignation(
    { getState, setState }: StateContext<DesignationStateModel>,
    {}: DesignationActions.ActivateDesignation
  ) {
    setState({ ...getState(), active: true });
  }

  @Action(DesignationActions.AddDesignation)
  addDesignation(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.AddDesignation
  ) {
    const state = getState();
    const finalPayload = { ...payload };
    if (payload.amount !== 0) {
      this.store.dispatch(
        new DonationActions.SetDonationAmount(state.total + payload.amount)
      );
    }

    if (state.items.length === 0) {
      finalPayload.amount = state.total;
    }

    setState({
      ...state,
      items: state.items.concat(finalPayload),
      total: state.total + payload.amount
    });
  }

  @Action(DesignationActions.RemoveDesignation)
  removeDesignation(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.RemoveDesignation
  ) {
    const state = getState();
    const newItems = state.items.filter((item, index) => index !== payload);
    const amount = newItems.reduce((val: any, item) => {
      return val + item.amount;
    }, 0);
    setState({ ...state, items: newItems, total: amount });
    this.store.dispatch(new DonationActions.SetDonationAmount(amount));
  }

  @Action(DesignationActions.ReplaceDesignation)
  replaceDesignation(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.ReplaceDesignation
  ) {
    const state = getState();

    if (payload.toUse.amount !== 0) {
      this.store.dispatch(new DonationActions.SetDonationAmount(state.total));
    }

    if (state.items.length === 1) {
      payload.toUse.amount = state.total;
    }

    setState({
      ...state,
      items: state.items.map(des =>
        des.id === payload.toReplace.id ? payload.toUse : des
      ),
      total: state.total
    });
  }

  @Action(DesignationActions.SetDesignations)
  setDesignations(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.SetDesignations
  ) {
    const state = getState();
    const amount = payload.reduce((val: any, item) => {
      return val + item.amount;
    }, 0);
    setState({ ...state, items: payload, total: amount });
    this.store.dispatch(new DonationActions.SetDonationAmount(amount));
  }

  @Action(DesignationActions.SetCustomDesignation)
  setCustomDesignation(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.SetCustomDesignation
  ) {
    const state = getState();
    setState({ ...state, custom: payload });
  }

  @Action(DesignationActions.SetNoteValue)
  setNoteValue(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.SetNoteValue
  ) {
    const state = getState();
    const exists = state.notes.findIndex(item => {
      return item.id === payload.index;
    });
    let newNotes;
    if (exists !== -1) {
      newNotes = state.notes.map(item =>
        item.id === payload.index
          ? { id: payload.index, value: payload.value }
          : item
      );
    } else {
      newNotes = state.notes.concat({
        id: payload.index,
        value: payload.value
      });
    }
    setState({ ...state, notes: newNotes });
  }

  @Action(DesignationActions.SetTotal)
  setTotal(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.SetTotal
  ) {
    const state = getState();

    if (state.items.length === 1) {
      setState({
        ...state,
        total: payload,
        items: [{ ...state.items[0], amount: payload }]
      });
    }

    if (state.items.length === 0) {
      setState({ ...state, total: payload });
    }
  }

  @Action(DesignationActions.SetCommentsValue)
  SetCommentsValue(
    { getState, setState }: StateContext<DesignationStateModel>,
    { payload }: DesignationActions.SetCommentsValue
  ) {
    const state = getState();
    setState({ ...state, p2pComments: payload });
  }
}
